<script setup lang="ts">

interface ITab {
  label: string;
  value: string | number;
}

interface ITabs {
  tabs: ITab[];
  modelValue: string | number;
}

const props = withDefaults(
    defineProps<ITabs>(),
    {
      modelValue: 0
    }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void
}>()

const change = (tab: ITab) => {
  emit('update:modelValue', tab.value);
}
</script>

<template>
  <div class="c-cu-tab">
    <div
        class="tab"
        v-for="(tab, index) in tabs"
        :key="index"
        :class="tab.value == modelValue ? 'active' : ''"
        @click="change(tab)"
    >
      <div class="tab__body">
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.c-cu-tab {
  border: 1px solid var(--color-border);
  background: var(--color-bg-secondary);
  border-radius: 14px;
  display: flex;
  padding: 4px;

  .tab {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    border-radius: 11px;
    cursor: pointer;
    background: transparent;
    color: var(--color-label);

    &:not(:last-child) {
      margin-right: 8px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        height: 16px;
        width: 1px;
        background: var(--color-border);
        right: -8px;
        top: calc(50% - 8px);
        cursor: default;
      }
    }

    &:not(:first-child) {
      margin-left: 8px;
    }

    &.active {
      background: var(--color-background);
      box-shadow: 0 0 4px 0 #A6A6A640;
    }

    &__body {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      background: transparent;
    }
  }
}
</style>
